import type { Messages } from '../catalogue.en'

/* Brand names stay Latin and untranslated in Hebrew copy; the components wrap
   them in `bdi`, and inside a sentence the joiner is a non-breaking hyphen so
   the preposition cannot separate from the name across the direction change. */
export const externalModules: Partial<Messages> = {
  'externalModule.genericConnection': 'מערכת חיצונית',
  'externalModule.connectionsUnavailable': 'המערכות החיצוניות אינן זמינות',
  'externalModule.connectionsUnavailableDetail':
    'לא ניתן היה לטעון מידע על חיבורים למערכות חיצוניות. רשומות המטופלים עצמן אינן מושפעות.',
  'externalModule.stateUnavailable': 'לא זמין',
  'externalModule.stateDisabled': 'מושבת',
  'externalModule.stateReconciliation': 'נדרשת התאמה',
  'externalModule.badgeUnavailable': '{name}: החיבור אינו זמין',
  'externalModule.badgeDisabled': '{name}: המודול מושבת',
  'externalModule.badgeReconciliation': '{name}: החיבור דורש התאמה',
  'externalModule.rowConnected': 'מחובר',
  'externalModule.rowOpenSection': 'פתיחת מדור {name} של מטופל זה',
  'externalModule.sectionTitle': 'מודול חיצוני',
  'externalModule.sectionLoadFailed': 'לא ניתן היה לטעון את מצב החיבור.',
  'externalModule.sectionUnknownTitle': 'מודול זה אינו זמין בסביבת עבודה זו',
  'externalModule.sectionUnknownDetail': 'הקישור מפנה למודול חיצוני שהמערכת אינה מארחת. תיק המטופל עצמו אינו מושפע.',
  'externalModule.sectionNotConnectedTitle': 'המטופל אינו מחובר',
  'externalModule.sectionNotConnectedDetail': 'לא קיים חיבור פעיל למודול זה עבור מטופל זה.',
  'externalModule.sectionUnavailableTitle': 'המודול אינו זמין כעת',
  'externalModule.sectionUnavailableDetail': 'החיבור קיים, אך המודול אינו מגיב כעת. נסו שוב מאוחר יותר.',
  'externalModule.sectionDisabledTitle': 'המודול מושבת',
  'externalModule.sectionDisabledDetail':
    'החיבור נשמר, אך המודול מושבת עבור מרפאה זו. המדור שלו יחזור כאשר המודול יופעל מחדש.',
  'externalModule.sectionReconciliationTitle': 'החיבור דורש התאמה',
  'externalModule.sectionReconciliationDetail':
    'יש להתאים את הקישור בין תיק זה למודול לפני שניתן יהיה לפתוח את המדור שלו.',
  'externalModule.sectionBackToChart': 'חזרה לתיק המטופל',
  'externalModule.workspaceLoading': 'זמינות המודול נבדקת…',
  'externalModule.workspaceUnavailableTitle': 'לא ניתן היה לטעון את מצב המודול',
  'externalModule.workspaceUnavailableDetail':
    'לא ניתן היה לקבוע כעת אם מודול זה זמין עבור המרפאה. נסו שוב מאוחר יותר.',
  'externalModule.boardCountPending': 'המונה טרם נטען',
  'externalModule.boardSectionPending': '{title}, המונה טרם נטען',
  'externalModule.alertsUnavailable': 'ההתראות אינן זמינות',
  'externalModule.alertsUnavailableDetail':
    'לא ניתן היה לטעון את מוני ההתראות הפתוחות. רשומות המטופלים עצמן אינן מושפעות.',
  'externalModule.alertsOpenOne': 'פתוחה אחת',
  'externalModule.alertsOpenMany': '{count} פתוחות',
  'externalModule.alertsCritical': '{count} דחופות',
  'externalModule.alertsReview': '{count} לעיון',
  'externalModule.alertsCellNamed': 'פתיחת סביבת העבודה של {name} עבור מטופל זה',
  'externalModule.alertsCellNamedEvent': 'פתיחת התראה זו של {name}',
  'externalModule.alertsFilterOpen': 'עם התראות פתוחות',
  'externalModule.criticalMarkOne': 'אירוע דחוף אחד פתוח ב‑{name}',
  'externalModule.criticalMarkMany': '{count} אירועים דחופים פתוחים ב‑{name}',
  'externalModule.criticalRowOne': 'אירוע דחוף',
  'externalModule.criticalRowMany': 'אירועים דחופים',
  'externalModule.criticalOpenEvent': 'פתיחת האירוע ב‑{name}',
  'externalModule.criticalOpenList': 'פתיחת האירועים של מטופל זה ב‑{name}',
  'externalModule.reminderAcknowledge': 'אישור',
  'externalModule.reminderGoToEvents': 'מעבר לאירועים',
  'externalModule.smartomica.connected': 'מחובר ל‑Smartomica',
  'externalModule.smartomica.sectionLabel': 'Smartomica',
  'externalModule.smartomica.sectionDescription': 'תת־מערכת חיצונית המחוברת לתיק זה',
  'externalModule.smartomica.navLabel': 'Smartomica',
  'externalModule.smartomica.navDescription': 'אירועים חיצוניים, סקירות והמלצות',
  'externalModule.smartomica.workspaceDisabledDetail':
    'אירועי Smartomica שנשמרו נשארים קריאים, אך שום דבר חדש אינו נטען ולא ניתן להריץ פקודות, המלצות או הודעות כל עוד המודול כבוי.',
  'externalModule.smartomica.statusNew': 'חדש',
  'externalModule.smartomica.statusOpened': 'נפתח',
  'externalModule.smartomica.statusUnderReview': 'בסקירה',
  'externalModule.smartomica.statusApproved': 'אושר',
  'externalModule.smartomica.statusClosed': 'נסגר',
  'externalModule.smartomica.statusEnteredInError': 'הוזן בטעות',
  'externalModule.smartomica.priorityCritical': 'דחוף',
  'externalModule.smartomica.priorityReview': 'לעיון',
  'externalModule.smartomica.deliveryPending': 'בשליחה',
  'externalModule.smartomica.deliverySimulated': 'שליחה מדומה',
  'externalModule.smartomica.deliveryAccepted': 'נשלח',
  'externalModule.smartomica.deliveryDelivered': 'נמסר',
  'externalModule.smartomica.deliveryRead': 'נקרא',
  'externalModule.smartomica.deliveryFailed': 'השליחה נכשלה',
  'externalModule.smartomica.simulationEvidence': 'הדמיה — לא בוצעה פנייה לספק רשת.',
  'externalModule.smartomica.responseAccepted': 'המטופל קיבל את ההמלצה',
  'externalModule.smartomica.responseDeclined': 'המטופל דחה את ההמלצה',
  'externalModule.smartomica.responseClarification': 'המטופל ביקש הבהרה',
  'externalModule.smartomica.responseNone': 'לא נרשמה תגובת מטופל',
  'externalModule.smartomica.itemObservation': 'הערה',
  'externalModule.smartomica.itemRecommendation': 'פעולה',
  'externalModule.smartomica.itemWarning': 'התרעה',
  'externalModule.smartomica.itemFollowUp': 'מעקב',
  'externalModule.smartomica.flowTitle': 'זרימת Smartomica',
  'externalModule.smartomica.flowLabel': 'אירועי Smartomica',
  'externalModule.smartomica.flowLoading': 'טוען את תור האירועים…',
  'externalModule.smartomica.flowLoadFailed': 'לא ניתן היה לטעון את תור האירועים.',
  'externalModule.smartomica.flowEmptyTitle': 'אין אירועים',
  'externalModule.smartomica.flowEmptyDetail': 'Smartomica עדיין לא שלחה אירועים עבור מרפאה זו.',
  'externalModule.smartomica.flowNoMatchesTitle': 'אין אירועים תואמים',
  'externalModule.smartomica.flowNoMatchesDetail':
    'אין אירועים התואמים את המסננים שהוחלו. נקו אותם כדי לראות את התור כולו.',
  'externalModule.smartomica.columnPatient': 'מטופל',
  'externalModule.smartomica.columnEvent': 'אירוע',
  'externalModule.smartomica.columnValue': 'ערך',
  'externalModule.smartomica.columnReceived': 'התקבל',
  'externalModule.smartomica.columnPriority': 'עדיפות',
  'externalModule.smartomica.columnStatus': 'סטטוס',
  'externalModule.smartomica.columnAssigned': 'משויך',
  'externalModule.smartomica.columnReviewed': 'נבדק',
  'externalModule.smartomica.columnOutcome': 'נשלח למטופל',
  'externalModule.smartomica.patientUnresolved': 'המטופל לא זוהה',
  'externalModule.smartomica.unassigned': 'לא משויך',
  'externalModule.smartomica.assignedUnresolved': 'השם לא זוהה',
  'externalModule.smartomica.assignedApplied': 'משויך שהוחל (לא בעמוד זה)',
  'externalModule.smartomica.reviewedNone': 'לא נבדק',
  'externalModule.smartomica.reviewClinicianUnresolved': 'הרופא לא זוהה',
  'externalModule.smartomica.outcomeNoMessage': 'לא נשלח',
  'externalModule.smartomica.outcomeSimulated': 'מדומה',
  'externalModule.smartomica.measuredAt': 'נמדד {time}',
  'externalModule.smartomica.receivedFrom': 'התקבל מ־',
  'externalModule.smartomica.receivedTo': 'התקבל עד',
  'externalModule.smartomica.priorityLocalTitle': 'העדיפות נקבעה על ידי כלל של מערכת זו, לא על ידי המקור',
  'externalModule.smartomica.prioritySourceTitle': 'העדיפות נמסרה על ידי המקור',
  'externalModule.smartomica.priorityOpensReview': '{priority} — פתיחת הסקירה של האירוע של {name}',
  'externalModule.smartomica.priorityOpensEventReview': '{priority} — פתיחת הסקירה של {name}',
  'externalModule.smartomica.eventTitle': 'סקירת אירוע',
  'externalModule.smartomica.dobLine': 'תאריך לידה {date}',
  'externalModule.smartomica.eventLoading': 'טוען את האירוע…',
  'externalModule.smartomica.eventLoadFailed': 'לא ניתן היה לטעון את האירוע.',
  'externalModule.smartomica.backToFlow': 'חזרה לזרימת Smartomica',
  'externalModule.smartomica.backToPatientSection': 'חזרה לתיק המטופל',
  'externalModule.smartomica.blockEvent': 'אירוע',
  'externalModule.smartomica.workflowLabel': 'התקדמות האירוע',
  'externalModule.smartomica.workflowReceived': 'התקבל',
  'externalModule.smartomica.workflowOpened': 'נפתח',
  'externalModule.smartomica.workflowAnalytics': 'האנליטיקה מוכנה',
  'externalModule.smartomica.workflowApproved': 'אושר',
  'externalModule.smartomica.workflowSent': 'נשלח למטופל',
  'externalModule.smartomica.workflowComplete': 'הושלם',
  'externalModule.smartomica.workflowCurrent': 'השלב הנוכחי',
  'externalModule.smartomica.workflowPending': 'לא הושלם',
  'externalModule.smartomica.workflowFailed': 'נכשל',
  'externalModule.smartomica.sourceLabel': 'מקור',
  'externalModule.smartomica.parameterLabel': 'פרמטר',
  'externalModule.smartomica.valueLabel': 'ערך',
  'externalModule.smartomica.rangeLabel': 'טווח תקין',
  'externalModule.smartomica.aboveRange': 'מעל הטווח התקין',
  'externalModule.smartomica.belowRange': 'מתחת לטווח התקין',
  'externalModule.smartomica.measuredLabel': 'נמדד',
  'externalModule.smartomica.noteSleepQuality': 'איכות השינה',
  'externalModule.smartomica.noteSleepComment': 'הערה על השינה',
  'externalModule.smartomica.noteAnxiety': 'חרדה',
  'externalModule.smartomica.noteSymptoms': 'תסמינים',
  'externalModule.smartomica.noteSymptomComment': 'הערה על התסמינים',
  'externalModule.smartomica.notePatientComment': 'הערת המטופל',
  'externalModule.smartomica.notePolydipsia': 'צמא מוגבר',
  'externalModule.smartomica.notePolyuria': 'השתנה תכופה',
  'externalModule.smartomica.noteMarkedWeakness': 'חולשה ניכרת',
  'externalModule.smartomica.noteNausea': 'בחילה',
  'externalModule.smartomica.noteVomiting': 'הקאות',
  'externalModule.smartomica.noteAbdominalPain': 'כאבי בטן',
  'externalModule.smartomica.noteConfusion': 'בלבול',
  'externalModule.smartomica.noteLossOfConsciousness': 'אובדן הכרה',
  'externalModule.smartomica.noteChestPain': 'כאבים בחזה',
  'externalModule.smartomica.noteDyspnea': 'קוצר נשימה',
  'externalModule.smartomica.noteFatigue': 'עייפות',
  'externalModule.smartomica.noteColdIntolerance': 'אי־סבילות לקור',
  'externalModule.smartomica.noteConstipation': 'עצירות',
  'externalModule.smartomica.noteDrySkin': 'יובש בעור',
  'externalModule.smartomica.noteHairLoss': 'נשירת שיער',
  'externalModule.smartomica.noteWeightGain': 'עלייה במשקל',
  'externalModule.smartomica.notePalpitations': 'דפיקות לב',
  'externalModule.smartomica.noteTremor': 'רעד',
  'externalModule.smartomica.noteMenstrualCycleChange': 'שינויים במחזור החודשי',
  'externalModule.smartomica.noteSleepPoor': 'ירודה',
  'externalModule.smartomica.noteSleepFair': 'סבירה',
  'externalModule.smartomica.noteSleepGood': 'טובה',
  'externalModule.smartomica.noteAnxietyNone': 'ללא',
  'externalModule.smartomica.noteAnxietyMild': 'קלה',
  'externalModule.smartomica.noteAnxietyModerate': 'בינונית',
  'externalModule.smartomica.noteAnxietySevere': 'חמורה',
  'externalModule.smartomica.noteYes': 'כן',
  'externalModule.smartomica.noteNo': 'לא',
  'externalModule.smartomica.noteNotProvided': 'לא צוין',
  'externalModule.smartomica.patientCommentLabel': 'הערת המטופל',
  'externalModule.smartomica.manualFallbackEvent': 'סקירה כשהניתוח אינו זמין',
  'externalModule.smartomica.manualFallbackSeedNote': 'נתוני הדגמה סינתטיים של Smartomica לסקירה ידנית כאשר הניתוח אינו זמין.',
  'externalModule.smartomica.patientCommentNone': 'אין הערה מהמטופל',
  'externalModule.smartomica.alsoReported': 'דווח גם',
  'externalModule.smartomica.askTitle': 'שאלו כל שאלה על ההיסטוריה הרפואית של המטופל',
  'externalModule.smartomica.askPlaceholder': 'מתי היה ה‑HbA1c האחרון? · אילו תרופות המטופל נוטל?',
  'externalModule.smartomica.askButton': 'שאלו',
  'externalModule.smartomica.askClinicianMark': 'ד"ר',
  'externalModule.smartomica.askPending': "מכינים תשובה…",
  'externalModule.smartomica.askLoading': "טוענים את השיחה שלך…",
  'externalModule.smartomica.askEmpty': "אין עדיין שאלות. השיחה זמינה רק לך במסגרת האירוע הזה.",
  'externalModule.smartomica.askFailed': "לא ניתן לקבל תשובה. השאלה נשמרה בשדה; אפשר לנסות שוב.",
  'externalModule.smartomica.askMissingSummary': "לאירוע הזה לא צורף מסמך סיכום קליני.",
  'externalModule.smartomica.askAlreadyRunning': "כבר מתבצעת הכנת תשובה. אפשר לנסות שוב בעוד רגע.",
  'externalModule.smartomica.askRequestReused': "הבקשה הזו כבר שימשה לשאלה אחרת. יש להזין שאלה חדשה.",
  'externalModule.smartomica.askHistoryLimit': "השיחה הגיעה לגודל ההקשר הנתמך.",
  'externalModule.smartomica.askReadOnly': "שאלות אינן זמינות בהרשאות שלך או במצב המודול הנוכחי.",
  'externalModule.smartomica.askBeforeReview': "שאלות יהיו זמינות לאחר תחילת הסקירה.",
  'externalModule.smartomica.askAfterReview': "שאלות זמינות רק כל עוד הסקירה פתוחה.",
  'externalModule.smartomica.askHistoryFailed': "לא ניתן לטעון את השיחה שלך.",
  'externalModule.smartomica.askUnsaved': "יש לך שאלה שלא נשלחה על הסיכום הקליני.",
  'externalModule.smartomica.askNote': 'התשובות מבוססות רק על התקציר שלהלן.',
  'externalModule.smartomica.summaryTitle': 'תקציר קליני',
  'externalModule.smartomica.summaryReceivedFrom': 'התקבל מ‑JWL',
  'externalModule.smartomica.summaryDownload': 'הורדה',
  'externalModule.smartomica.summaryLoading': 'קורא את התקציר…',
  'externalModule.smartomica.summaryUnreadable': 'לא ניתן היה לקרוא את טקסט התקציר. הורידו את המסמך כדי לקרוא אותו.',
  'externalModule.smartomica.summaryShowFull': 'הצגת התקציר המלא',
  'externalModule.smartomica.summaryShowLess': 'הצגת פחות',
  'externalModule.smartomica.analyticsTitle': 'אנליטיקת Smartomica',
  'externalModule.smartomica.startReview': 'התחלת סקירה',
  'externalModule.smartomica.analyticsLoading': 'טוען המלצות…',
  'externalModule.smartomica.analyticsFailed': 'לא ניתן היה לטעון את ההמלצות.',
  'externalModule.smartomica.analyticsWriteInstead': 'כתבו את ההמלצה למטה.',
  'externalModule.smartomica.analyticsRetry': 'ניסיון נוסף',
  'externalModule.smartomica.analyticsPartial':
    'חלק מההמלצות לא נטענו; ייתכן שהרשימה חלקית. בדקו אותה לפני האישור.',
  'externalModule.smartomica.analyticsNone': 'אין המלצות עדיין.',
  'externalModule.smartomica.analyticsLoad': 'טעינת המלצות',
  'externalModule.smartomica.reviewNotOffered': 'סקירה אינה מוצעת לחשבון זה.',
  'externalModule.smartomica.approvalNotOffered': 'אישור ושליחה אינם מוצעים לחשבון זה.',
  'externalModule.smartomica.editRecommendation': 'עריכת המלצה {number}',
  'externalModule.smartomica.recommendationRequired': 'יש להזין טקסט בכל המלצה.',
  'externalModule.smartomica.writingTitle': 'דברי הרופא',
  'externalModule.smartomica.writingPlaceholder': 'כתבו או הכתיבו את הטקסט',
  'externalModule.smartomica.dictationTitle': 'הכתבה',
  'externalModule.smartomica.dictationCancel': 'ביטול ההכתבה',
  'externalModule.smartomica.dictationIntro': 'הקליטו את הטקסט. לאחר העצירה, המילים שזוהו יתווספו לשדה בשפת ההקלטה.',
  'externalModule.smartomica.dictationStop': 'עצירה והוספה',
  'externalModule.smartomica.dictationProcessing': 'זיהוי הדיבור…',
  'externalModule.smartomica.dictationTooLong': 'הטקסט שזוהה ארוך מדי לשדה זה. הקליטו קטע קצר יותר.',
  'externalModule.smartomica.dictationTooLarge': 'ההקלטה גדולה מ־25 מ״ב. הקליטו קטע קצר יותר.',
  'externalModule.smartomica.dictationForbidden': 'אין לך עוד גישה להכתבה עבור אירוע זה.',
  'externalModule.smartomica.dictationUnsaved': 'הקלטה בסמארטומיקה שנמצאת בזיהוי',
  'externalModule.smartomica.askMic': 'הכתבת השאלה',
  'externalModule.smartomica.dictate': 'הכתבה',
  'externalModule.smartomica.unsavedDraft': 'טיוטת המלצה של Smartomica',
  'externalModule.smartomica.draftSaving': 'שומר את הטיוטה…',
  'externalModule.smartomica.draftSaved': 'הטיוטה נשמרה {time}',
  'externalModule.smartomica.draftUnsaved': 'יש שינויים שלא נשמרו',
  'externalModule.smartomica.previewHeading': 'ההודעה שהמטופל יקבל',
  'externalModule.smartomica.previewEmpty': 'סמנו לפחות פריט אחד או כתבו הערה.',
  'externalModule.smartomica.attestation': 'אני מאשר/ת שבדקתי הודעה זו ומאשר/ת אותה כהמלצתי.',
  'externalModule.smartomica.sending': 'שולח…',
  'externalModule.smartomica.approvedAt': 'אושר {time}',
  'externalModule.smartomica.credentialLine': 'רישיון {licence}, {issuer}, {jurisdiction}',
  'externalModule.smartomica.messageHeading': 'הודעה למטופל',
  'externalModule.smartomica.deliveryLabel': 'מסירה',
  'externalModule.smartomica.responseLabel': 'תגובת המטופל',
  'externalModule.smartomica.sendToPatient': 'שליחה למטופל',
  'externalModule.smartomica.retrySend': 'ניסיון שליחה חוזר',
  'externalModule.smartomica.commandFailed': 'לא ניתן היה להשלים את הפעולה.',
  'externalModule.smartomica.commandDisabled': 'המודול כבוי; פקודות אינן זמינות.',
  'externalModule.smartomica.conflictNotice':
    'האירוע השתנה בזמן שעבדתם. העובדות העדכניות נטענו מחדש; הטקסט שלכם נשמר — בדקו אותו ונסו שוב.',
  'externalModule.smartomica.notReviewable': 'אירוע זה אינו במצב הניתן לסקירה.',
  'externalModule.smartomica.credentialRefused': 'לא ניתן היה לאמת את האישור הקליני שלכם, ולכן האישור נדחה.',
  'externalModule.smartomica.dashboardTitle': 'Smartomica',
  'externalModule.smartomica.dashboardUnit': 'אירועים פתוחים',
  'externalModule.smartomica.dashboardLink': 'פתיחת הזרימה',
  'externalModule.smartomica.dashboardLoading': 'טוען את הסיכום…',
  'externalModule.smartomica.dashboardLoadFailed': 'לא ניתן היה לטעון את הסיכום.',
  // The board tile's counter pills: what arrived over the served clinic days,
  // each name a pill's hover hint.
  'externalModule.smartomica.sparkCritical': 'דחופים',
  'externalModule.smartomica.sparkReview': 'לעיון',
  'externalModule.smartomica.sparkNewPatients': 'מטופלים חדשים',
  'externalModule.smartomica.sparkPeriod': "הגעות, {days} ימ'",
  'externalModule.smartomica.reminderTitle': 'יש אירועי Smartomica דחופים פתוחים',
  'externalModule.smartomica.reminderBodyOne':
    'אירוע דחוף אחד ממתין להחלטה. פתחו אותו כדי לבדוק ולהשיב למטופל.',
  'externalModule.smartomica.reminderBodyMany':
    '{count} אירועים דחופים ממתינים להחלטה. פתחו אותם כדי לבדוק ולהשיב למטופלים.',
  'externalModule.smartomica.recentTitle': 'אירועים אחרונים',
  'externalModule.smartomica.recentEmpty': 'אין אירועים אחרונים.',
  'externalModule.smartomica.sectionEventsLoading': 'טוען את האירועים של מטופל זה…',
  'externalModule.smartomica.patientEventsFailed': 'לא ניתן היה לטעון את אירועי Smartomica של מטופל זה.',
  'externalModule.smartomica.patientEventsTitle': 'אירועים',
  'externalModule.smartomica.patientEventsLabel': 'אירועי Smartomica של מטופל זה',
  'externalModule.smartomica.patientEventsEmptyTitle': 'אין אירועי Smartomica',
  'externalModule.smartomica.patientEventsEmptyDetail': 'Smartomica עדיין לא שלחה אירועים עבור מטופל זה.',
  'externalModule.smartomica.patientEventsNoMatchesTitle': 'אין אירועים תואמים',
  'externalModule.smartomica.patientEventsNoMatchesDetail':
    'אין אירועים התואמים למסנני הטבלה. נקו אותם כדי לראות את כל האירועים.',
  'externalModule.smartomica.patientEventsClosedHidden': 'אירועים סגורים מוסתרים',
  'externalModule.smartomica.patientEventsClosedShow': 'הצגת אירועים סגורים',
  'externalModule.smartomica.reviewHistoryTitle': 'היסטוריית סקירות',
  'externalModule.smartomica.reviewHistoryLoading': 'טוען את היסטוריית הסקירות…',
  'externalModule.smartomica.reviewHistoryFailed': 'לא ניתן היה לטעון את היסטוריית הסקירות.',
  'externalModule.smartomica.reviewHistoryEmpty': 'עדיין אין סקירות מתועדות.',
  'externalModule.smartomica.reviewHistoryNoneOnPage':
    'אין סקירות Smartomica בחלק שנטען מציר הזמן. טענו עוד כדי להמשיך לחפש.',
  'externalModule.smartomica.reviewHistoryMore': 'טעינת היסטוריה נוספת',
  'externalModule.smartomica.alertsColumnLabel': 'התראות',
  'externalModule.smartomica.alertsColumnDescription': 'אירועי Smartomica פתוחים לכל מטופל: סך הכול, דחופים ולעיון.',
  'externalModule.smartomica.settings.integration': 'חיבור האינטגרציה',
  'externalModule.smartomica.settings.loading': 'טוען את הגדרות האינטגרציה…',
  'externalModule.smartomica.settings.loadFailed': 'לא ניתן היה לטעון את הגדרות Smartomica.',
  'externalModule.smartomica.settings.forbidden': 'לחשבון זה אין הרשאה לנהל את הגדרות Smartomica.',
  'externalModule.smartomica.settings.endpoint': 'נקודת קצה לאינטגרציה',
  'externalModule.smartomica.settings.clientCode': 'קוד לקוח',
  'externalModule.smartomica.settings.token': 'אסימון',
  'externalModule.smartomica.settings.tokenStored': 'נשמר בצורה מאובטחת; הערך לעולם אינו מוחזר.',
  'externalModule.smartomica.settings.tokenReplaceHint': 'השאירו ריק כדי לשמור את האסימון הקיים, או הזינו אסימון חדש כדי להחליפו.',
  'externalModule.smartomica.settings.tokenRequiredHint': 'יש להזין אסימון באורך 32 עד 256 תווים.',
  'externalModule.smartomica.settings.change': 'שינוי הגדרות האינטגרציה',
  'externalModule.smartomica.settings.set': 'הגדרת האינטגרציה',
  'externalModule.smartomica.settings.save': 'שמירת הגדרות',
  'externalModule.smartomica.settings.saving': 'שומר הגדרות…',
  'externalModule.smartomica.settings.saved': 'הגדרות Smartomica נשמרו.',
  'externalModule.smartomica.settings.saveFailed': 'לא ניתן היה לשמור את הגדרות Smartomica.',
  'externalModule.smartomica.settings.conflict': 'ההגדרות השתנו במקום אחר. יש לטעון אותן מחדש לפני שמירה נוספת.',
  'externalModule.smartomica.settings.unsaved': 'בהגדרות Smartomica יש שינויים שלא נשמרו.',
  'externalModule.smartomica.debug.title': 'ניפוי שגיאות של Smartomica',
  'externalModule.smartomica.debug.subtitle':
    'אירועים מוכנים שנשלחים דרך קליטת Smartomica הרגילה; פעולות חיצוניות משתמשות בספקים המוגדרים של הסביבה.',
  'externalModule.smartomica.debug.target': 'מטופל יעד',
  'externalModule.smartomica.debug.patient': 'מטופל לאירועים מקושרים',
  'externalModule.smartomica.debug.patientPlaceholder': 'חיפוש מטופל',
  'externalModule.smartomica.debug.patientNone': 'לא נבחר מטופל',
  'externalModule.smartomica.debug.patientDirectoryUnavailable': 'לחשבון זה אין הרשאה לקרוא את ספריית זהויות המטופלים, ולכן התרחישים המקושרים אינם זמינים.',
  'externalModule.smartomica.debug.moduleState': 'מוכנות המודול',
  'externalModule.smartomica.debug.moduleReady': 'המודול מופעל וגלוי; קליטת ניפוי השגיאות זמינה.',
  'externalModule.smartomica.debug.moduleInactive': 'יש להפעיל ולהציג את המודול לפני שליחת אירועי ניפוי שגיאות.',
  'externalModule.smartomica.debug.scenarios': 'אירועים מוכנים',
  'externalModule.smartomica.debug.incoming_patient.title': 'קליטת מטופל',
  'externalModule.smartomica.debug.incoming_patient.detail': 'יוצר מטופל סינתטי, משייך אותו לרופא המוגדר ושולח לרופא הודעה. אם נבחר מטופל, הרשומה החדשה משתמשת בשם, בתאריך הלידה ובמין מאותו תיק; מזהה Smartomica חדש עדיין יוצר תיק נפרד.',
  'externalModule.smartomica.debug.existing_patient.title': 'מטופל קיים',
  'externalModule.smartomica.debug.existing_patient.detail': 'שולח אירוע קליטה עם מדידת דופק ממופה אחת עבור המטופל המקושר שנבחר.',
  'externalModule.smartomica.debug.vital_signs.title': 'מדדים חיוניים',
  'externalModule.smartomica.debug.vital_signs.detail': 'שולח דופק ולחץ דם ממופים עבור המטופל המקושר שנבחר.',
  'externalModule.smartomica.debug.review.title': 'אירוע לעיון',
  'externalModule.smartomica.debug.review.detail': 'שולח תוצאה של הורמון מגרה בלוטת התריס 6.2, תירוקסין חופשי 14.5, ויטמין די 18 ותלונות על עייפות, חרדה ושינה לקויה לעיון.',
  'externalModule.smartomica.debug.critical.title': 'אירוע דחוף',
  'externalModule.smartomica.debug.critical.detail': 'שולח גלוקוז בצום 288 מיליגרם לדציליטר עם קטונים חיוביים, הקאות, כאבי בטן וצמא, ומפעיל התראה מיידית.',
  'externalModule.smartomica.debug.send': 'שליחת אירוע',
  'externalModule.smartomica.debug.sending': 'שולח…',
  'externalModule.smartomica.debug.result': 'תוצאה אחרונה',
  'externalModule.smartomica.debug.resultState': 'תוצאת הקליטה',
  'externalModule.smartomica.debug.resultCandidate': 'התקבל להתאמה למטופל.',
  'externalModule.smartomica.debug.resultAccepted': 'התקבל וקושר למטופל שנבחר.',
  'externalModule.smartomica.debug.openEvent': 'פתיחת האירוע שנוצר',
  'externalModule.smartomica.debug.patientNotLinked': 'למטופל שנבחר אין זהות Smartomica פעילה. יש לקשר את המטופל תחילה בתהליך ההתאמה.',
  'externalModule.smartomica.debug.forbidden': 'לחשבון זה אין עוד הרשאה להריץ אירועי ניפוי שגיאות של Smartomica.',
  'externalModule.smartomica.debug.unavailable': 'המודול כבוי או שסביבת ניפוי השגיאות של Smartomica אינה זמינה.',
  'externalModule.smartomica.debug.failed': 'לא ניתן היה לשלוח את אירוע Smartomica המוכן.',
  // The incoming Patients — the reconciliation queue and its decision panel.
  'externalModule.smartomica.incomingTitle': 'מטופלים נכנסים',
  'externalModule.smartomica.incomingDetail':
    'אנשים ש‑Smartomica שלחה וזהותם עדיין לא מקושרת לאף מטופל. כל אחד ממתין להחלטה: לקשר מטופל קיים או לרשום מטופל חדש.',
  'externalModule.smartomica.incomingCount': 'ממתינים: {count}',
  'externalModule.smartomica.incomingBackToFlow': 'חזרה לזרימת Smartomica',
  'externalModule.smartomica.incomingLink.counted': 'מטופלים נכנסים: {count}',
  'externalModule.smartomica.incomingLink.uncounted': 'מטופלים נכנסים',
  'externalModule.smartomica.incomingDisabledDetail':
    'זהויות נכנסות נשארות קריאות, אך קישור ורישום אינם זמינים כל עוד המודול כבוי.',
  'externalModule.smartomica.incomingLoading': 'טוען מטופלים נכנסים…',
  'externalModule.smartomica.incomingLoadFailed': 'לא ניתן היה לטעון את המטופלים הנכנסים.',
  'externalModule.smartomica.incomingEmptyTitle': 'אין מטופלים נכנסים',
  'externalModule.smartomica.incomingEmptyDetail': 'כל זהות ש‑Smartomica שלחה מקושרת למטופל.',
  'externalModule.smartomica.incomingListLabel': 'מטופלים נכנסים הממתינים להחלטה',
  'externalModule.smartomica.incomingUnnamed': 'אדם ללא שם',
  'externalModule.smartomica.incomingFactUnknown': 'לא צוין',
  'externalModule.smartomica.incomingSexUnknown': 'לא צוין',
  'externalModule.smartomica.incomingReceived': 'התקבל לראשונה',
  'externalModule.smartomica.incomingHeld': 'אירועים מוחזקים',
  'externalModule.smartomica.incomingHeldCount': '{count}',
  'externalModule.smartomica.incomingMatchesTitle': 'מטופלים קיימים אפשריים: {count}',
  'externalModule.smartomica.incomingMatchesFor': 'מטופלים קיימים אפשריים עבור {name}',
  'externalModule.smartomica.incomingNoMatchTitle': 'אין מטופל תואם במרשם',
  'externalModule.smartomica.incomingNoMatchDetail':
    'אף מטופל פעיל במרפאה זו אינו חולק את שמו של אדם זה, או את תאריך לידתו יחד עם אחד מהשמות.',
  'externalModule.smartomica.incomingNameAgrees': 'השם תואם',
  'externalModule.smartomica.incomingBirthDateAgrees': 'תאריך הלידה תואם',
  'externalModule.smartomica.incomingDecide': 'להחליט',
  'externalModule.smartomica.incomingDecisionEyebrow': 'מטופל נכנס',
  'externalModule.smartomica.incomingChooseLegend': 'לקשר לאיזה מטופל?',
  'externalModule.smartomica.incomingAnotherPatient': 'מטופל אחר מהמרשם',
  'externalModule.smartomica.incomingAnotherPatientField': 'מטופל',
  'externalModule.smartomica.incomingChosenPatient': 'המטופל שנבחר',
  'externalModule.smartomica.incomingChooseFirst': 'תחילה יש לבחור את המטופל לקישור.',
  'externalModule.smartomica.incomingLink': 'לקשר מטופל',
  'externalModule.smartomica.incomingLinking': 'מקשר…',
  'externalModule.smartomica.incomingRegisterNew': 'לרשום כמטופל חדש',
  'externalModule.smartomica.incomingRetryLink': 'לקשר את המטופל שנרשם',
  'externalModule.smartomica.incomingRegisteredNotLinked':
    '{name} נרשם/ה, אך עדיין לא ניתן היה לקשר את זהות Smartomica. התיק נשמר; יש לקשר שוב.',
  'externalModule.smartomica.registerReason': 'נרשם/ה כמטופל חדש מתוך זהות Smartomica נכנסת.',
  'externalModule.smartomica.incomingConfirmTitle': 'לקשר מטופל זה לזהות Smartomica?',
  'externalModule.smartomica.incomingConfirmDetail':
    'האדם הנכנס "{incoming}" יקושר אל {patient}. אירועים מוחזקים ישוחררו לזרימה ויופיעו בתיק.',
  'externalModule.smartomica.incomingConfirmCancel': 'להמשיך להחליט',
  'externalModule.smartomica.incomingReasonLegend': 'מדוע זה אותו אדם?',
  'externalModule.smartomica.linkReasonSamePerson': 'אותו אדם לפי שם ותאריך לידה',
  'externalModule.smartomica.linkReasonConfirmed': 'אומת מול המטופל',
  'externalModule.smartomica.linkReasonSourceIdentifier': 'הותאם לפי המזהה של המקור',
  'externalModule.smartomica.incomingReasonOther': 'סיבה אחרת',
  'externalModule.smartomica.incomingReasonDetail': 'פירוט הסיבה',
  'externalModule.smartomica.incomingReasonHint': 'הסיבה נרשמת יחד עם הקישור ולא ניתן לערוך אותה לאחר מכן.',
  'externalModule.smartomica.incomingLinkedNotice': 'קושר אל {name}. הרשומה הוסרה מרשימת הנכנסים.',
  'externalModule.smartomica.incomingOpenChart': 'לפתוח את התיק',
  'externalModule.smartomica.recipientMismatch': 'המטופל הזה משויך לרופא אחר בסמארטומיקה. יש לבחור מטופל שמשויך אליך.',
  'externalModule.smartomica.alreadyConnected': 'למטופל כבר יש מזהה פעיל ב־Smartomica. המטופל הנכנס לא קושר.',
  'externalModule.smartomica.connectionChanged': 'הקישור ל־Smartomica השתנה. יש לבטל ולנסות לקשר שוב כדי לאשר את הקישור הנוכחי.',
  'externalModule.smartomica.replaceTitle': 'להחליף את הקישור ל־Smartomica?',
  'externalModule.smartomica.replaceDetail': 'למטופל {patient} כבר יש מזהה פעיל ב־Smartomica. להחליף אותו במזהה של המטופל הנכנס? נתונים עתידיים יתקבלו דרך הקישור החדש. אירועים שכבר התקבלו וההיסטוריה הרפואית יישמרו. המזהה הישן לא יקבל עוד נתונים חדשים.',
  'externalModule.smartomica.replaceConfirm': 'החלפה וקישור',
  'externalModule.smartomica.discardIncoming': 'דחיית המטופל הנכנס',
  'externalModule.smartomica.discardDetail': 'לדחות את הרשומה הנכנסת של {name} בלי לקשר אותה לתיק? רק הנתונים הממתינים ברשומה זו יידחו. אירועים קיימים וההיסטוריה הרפואית יישארו ללא שינוי. נתוני המקור וסיבת הדחייה יישמרו.',
  'externalModule.smartomica.discardFailed': 'לא ניתן היה לדחות את המטופל הנכנס.',
  'externalModule.smartomica.discardReasonLegend': 'מהי הסיבה לדחיית המטופל הנכנס?',
  'externalModule.smartomica.discardReasonTest': 'רשומת ניסיון',
  'externalModule.smartomica.discardReasonWrongPatient': 'התקבל בטעות',
  'externalModule.smartomica.reconcileFailed': 'לא ניתן היה לקשר את המטופל.',
  'externalModule.smartomica.reconcileConflict': 'רשומה זו השתנתה בזמן ההחלטה. יש לטעון מחדש את הרשימה ולהחליט שוב.',
  'externalModule.smartomica.reconcileAlreadyLinked': 'רשומה זו כבר מקושרת למטופל.',
  'externalModule.smartomica.reconcileGone': 'רשומה זו כבר אינה ממתינה.',
  'externalModule.smartomica.reconcilePatientNotFound': 'המטופל שנבחר לא נמצא במרפאה זו.',
  "externalModule.ondoc.connected": "מחובר ל־OnDoc",
  "externalModule.ondoc.sectionLabel": "חיבור ל־OnDoc",
  "externalModule.ondoc.connectionDescription": "שיוך מטופל וקודי חיבור",
  "externalModule.ondoc.navLabel": "OnDoc",
  "externalModule.ondoc.navDescription": "בקשות תורים, יומן חילופי נתונים ושיוך מטופלים",
  "externalModule.ondoc.areaNavigation": "מדורי OnDoc",
  "externalModule.ondoc.bookingsNavDetail": "בקשות מ־OnDoc הממתינות לבחירת תיק",
  "externalModule.ondoc.journalNavDetail": "פעולות חילופי הנתונים האחרונות מול OnDoc",
  "externalModule.ondoc.attachmentView": "שיוך המטופל",
  "externalModule.ondoc.attachmentNavDetail": "מצב השיוך וקודי החיבור עבור תיק אחד",
  "externalModule.ondoc.choosePatient": "יש לבחור מטופל",
  "externalModule.ondoc.choosePatientDetail": "יש לבחור תיק למעלה כדי לראות את פרטיו ב־OnDoc.",
  "externalModule.ondoc.readFailed": "לא ניתן לטעון את פרטי החיבור ל־OnDoc.",
  "externalModule.ondoc.codeFailed": "לא ניתן לקבל את הקוד. ייתכן שהבקשה הצליחה; יש לבדוק ב־OnDoc לפני בקשת קוד נוסף.",
  "externalModule.ondoc.disabled": "OnDoc מושבת. פרטי החיבור השמורים עדיין זמינים.",
  "externalModule.ondoc.configurationRequired": "יש לפנות למנהל להגדרת OnDoc עבור ארגון זה.",
  "externalModule.ondoc.configurationChanged": "הגדרות החיבור השתנו. יש לטעון מחדש את הפרטים לפני בקשת קוד.",
  "externalModule.ondoc.profileIncomplete": "יש לבדוק את שם המטופל, תאריך הלידה ופרטי הקשר לפני בקשת קוד חיבור.",
  "externalModule.ondoc.branchUnavailable": "הסניף אינו זמין",
  "externalModule.ondoc.network": "כל רשת הארגון",
  "externalModule.ondoc.scope": "תחום השיוך",
  "externalModule.ondoc.status": "שיוך",
  "externalModule.ondoc.attached": "משויך",
  "externalModule.ondoc.detached": "השיוך בוטל",
  "externalModule.ondoc.connectedAt": "מועד השיוך",
  "externalModule.ondoc.disconnectedAt": "מועד ביטול השיוך",
  "externalModule.ondoc.loading": "פרטי החיבור נטענים…",
  "externalModule.ondoc.attachments": "שיוך ל־OnDoc לפי תחום",
  "externalModule.ondoc.noAttachment": "אין שיוך מאושר",
  "externalModule.ondoc.noAttachmentDetail": "הנפקת קוד חיבור אינה מאשרת את שיוך המטופל.",
  "externalModule.ondoc.noMatches": "לא נמצאו שיוכים מתאימים",
  "externalModule.ondoc.noMatchesDetail": "יש לשנות את מסנני הטבלה.",
  "externalModule.ondoc.codeTitle": "קוד חיבור",
  "externalModule.ondoc.branch": "סניף",
  "externalModule.ondoc.branchesFailed": "לא ניתן לטעון את רשימת הסניפים.",
  "externalModule.ondoc.requestingCode": "הקוד מתבקש…",
  "externalModule.ondoc.requestCode": "בקשת קוד חיבור",
  "externalModule.ondoc.codeLabel": "קוד חיבור:",
  "externalModule.ondoc.codeHint": "יש למסור את הקוד למטופל. OnDoc מאשר את השיוך בנפרד; יש לרענן להצגת המצב העדכני.",
  "externalModule.ondoc.patient": "מטופל",
  "externalModule.ondoc.eventUnavailable": "רשומה זו ב־OnDoc אינה זמינה.",
  "externalModule.ondoc.refresh": "רענון השיוך",
  "externalModule.ondoc.bookingsFailed": "לא ניתן לטעון את תור בקשות התורים.",
  "externalModule.ondoc.resolveFailed": "לא ניתן לאשר את התיק. יש לשמור את הבחירה ולרענן את התור לפני ניסיון נוסף.",
  "externalModule.ondoc.bookingChanged": "הבקשה השתנתה. יש לרענן את התור לפני בחירה נוספת של תיק.",
  "externalModule.ondoc.awaitingRegistrar": "ממתין לבחירת תיק",
  "externalModule.ondoc.bookingFailed": "העיבוד נכשל",
  "externalModule.ondoc.bookingAmbiguous": "יש לבדוק את התוצאה ב־OnDoc",
  "externalModule.ondoc.bookingUnknown": "מצב עיבוד לא מוכר",
  "externalModule.ondoc.bookingStart": "מועד התור",
  "externalModule.ondoc.bookingActions": "פעולות עבור התור",
  "externalModule.ondoc.bookingsRefresh": "רענון התור",
  "externalModule.ondoc.bookingOpen": "עיון בבקשת התור",
  "externalModule.ondoc.bookingOpenNamed": "עיון בבקשת התור של {name}",
  "externalModule.ondoc.bookings": "בקשות תורים נכנסות",
  "externalModule.ondoc.noBookings": "אין בקשות הממתינות לעיבוד",
  "externalModule.ondoc.noBookingsDetail": "בקשות תורים מ־OnDoc שטרם טופלו יופיעו כאן.",
  "externalModule.ondoc.bookingUnsaved": "בחירת תיק שטרם אושרה עבור תור מ־OnDoc",
  "externalModule.ondoc.resolveBooking": "אישור התיק ועיבוד התור",
  "externalModule.ondoc.bookingFactsHint": "הנתונים האלה התקבלו מ־OnDoc. בחירת תיק אינה משנה את פרטיו ואינה מחברת את המטופל ל־OnDoc.",
  "externalModule.ondoc.birthDate": "תאריך הלידה שנמסר ב־OnDoc",
  "externalModule.ondoc.phone": "הטלפון שנמסר ב־OnDoc",
  "externalModule.ondoc.email": "הדוא״ל שנמסר ב־OnDoc",
  "externalModule.ondoc.comment": "הערת המטופל",
  "externalModule.ondoc.chartCreated": "התיק נרשם; יש לאשר אותו עבור התור הזה:",
  "externalModule.ondoc.chooseChart": "בחירת תיק המטופל",
  "externalModule.ondoc.registerChart": "רישום תיק מטופל חדש",
  "externalModule.ondoc.bookingDiscardDetail": "רק הבחירה שטרם אושרה תנוקה. תיק שכבר נרשם יישמר.",
  "externalModule.ondoc.keepChoice": "שמירת הבחירה",
  "externalModule.ondoc.discardChoice": "ניקוי הבחירה",
  "externalModule.ondoc.settings.title": "הגדרות החיבור",
  "externalModule.ondoc.settings.failed": "לא ניתן לשמור את ההגדרות. יש לבדוק את ההתאמות ואת שדות החובה.",
  "externalModule.ondoc.settings.conflict": "ההגדרות או מצב המודול השתנו. יש לטעון את ההגדרות העדכניות לפני המשך העבודה.",
  "externalModule.ondoc.settings.connectionLocked": "החלפת הסביבה, הרשת או היקף השיוך של חיבור קיים מחייבת בירור ההתאמות.",
  "externalModule.ondoc.settings.bindingLocked": "לא ניתן לשייך מחדש התאמה קיימת ב־OnDoc. יש לשחזר את ההתאמה השמורה.",
  "externalModule.ondoc.settings.priceInvalid": "יש לבחור לכל סניף מחירון ציבורי פעיל במטבע שהוגדר ובדיוק של שתי ספרות עשרוניות.",
  "externalModule.ondoc.settings.serviceInvalid": "יש לבדוק את השירותים שנבחרו ואת ההתמחויות שלהם ב־OnDoc.",
  "externalModule.ondoc.settings.typeInvalid": "יש לבחור סוג תור שפורסם ושמשך הזמן שלו מתאים.",
  "externalModule.ondoc.settings.scheduleInvalid": "יש לבדוק את הסניף, הרופא, מקום העבודה והשירותים. לוח תורים אחד משתמש בגרסה אחת שפורסמה של סוג תור.",
  "externalModule.ondoc.settings.forbidden": "אין הרשאה לנהל את ההגדרות האלה.",
  "externalModule.ondoc.settings.unsaved": "הגדרות חיבור ל־OnDoc שלא נשמרו",
  "externalModule.ondoc.settings.loadFailed": "לא ניתן לטעון את הגדרות החיבור.",
  "externalModule.ondoc.settings.resumed": "החלפת הנתונים חודשה עבור ההגדרות הנוכחיות.",
  "externalModule.ondoc.settings.paused": "החלפת הנתונים מושהית. יש לבדוק את ההגדרות לפני חידושה.",
  "externalModule.ondoc.settings.notConfigured": "OnDoc עדיין אינו מוגדר עבור ארגון זה.",
  "externalModule.ondoc.settings.edit": "עיון בהגדרות או עריכתן",
  "externalModule.ondoc.settings.resume": "חידוש החלפת הנתונים",
  "externalModule.ondoc.settings.savePauses": "שמירה משהה את החלפת הנתונים. יש לחדש אותה בנפרד לאחר בדיקת ההגדרות שנשמרו.",
  "externalModule.ondoc.settings.environment": "סביבת OnDoc",
  "externalModule.ondoc.settings.stage": "סביבת בדיקות",
  "externalModule.ondoc.settings.production": "סביבת ייצור",
  "externalModule.ondoc.settings.network": "מזהה הרשת ב־OnDoc",
  "externalModule.ondoc.settings.attachmentMode": "היקף שיוך המטופל",
  "externalModule.ondoc.settings.publicToken": "מפתח Public API של הרשת",
  "externalModule.ondoc.settings.tokenRetained": "מפתח נשמר. יש להשאיר את השדה ריק כדי לשמור עליו.",
  "externalModule.ondoc.settings.tokenRequired": "יש להזין את המפתח שסופק על ידי OnDoc.",
  "externalModule.ondoc.settings.currency": "קוד המטבע של המחירים ב־OnDoc",
  "externalModule.ondoc.settings.horizon": "מספר ימי הזמינות לפרסום, כולל היום (1–365)",
  "externalModule.ondoc.settings.save": "שמירת ההגדרות",
  "externalModule.ondoc.settings.cancel": "ביטול העריכה",
  "externalModule.ondoc.settings.reload": "החלפת הטיוטה בהגדרות השמורות העדכניות",
  "externalModule.ondoc.settings.reloadFailed": "לא ניתן לטעון את ההגדרות העדכניות. הטיוטה נשמרה.",
  "externalModule.ondoc.settings.discardDetail": "האם לבטל את ההגדרות שלא נשמרו ואת המפתחות שהוזנו בטופס הזה? המפתחות השמורים יישארו.",
  "externalModule.ondoc.settings.sourceUnavailable": "המקור השמור אינו זמין",
  "externalModule.ondoc.settings.removeMapping": "הסרת ההתאמה הזאת",
  "externalModule.ondoc.settings.branches": "סניפים ומחירונים ציבוריים",
  "externalModule.ondoc.settings.services": "שירותים",
  "externalModule.ondoc.settings.doctors": "רופאים",
  "externalModule.ondoc.settings.schedules": "לוחות תורים להזמנה",
  "externalModule.ondoc.settings.mappingHint": "יש לבחור מקורות קיימים ב־Terysling. שמירת ההתאמות אינה משנה מחירונים, רופאים או לוחות תורים. מזהים לפרסומים חדשים מוקצים על ידי האינטגרציה.",
  "externalModule.ondoc.settings.sourcesFailed": "לא ניתן לטעון מקור להתאמות. הבחירות השמורות נשמרות.",
  "externalModule.ondoc.settings.sourceGrants": "בחירת התאמות חדשות מחייבת הרשאות לקריאת מחירונים, רופאים וסוגי תורים.",
  "externalModule.ondoc.settings.branchMapping": "התאמת סניף",
  "externalModule.ondoc.settings.branchIdentifier": "מזהה הסניף ב־OnDoc",
  "externalModule.ondoc.settings.priceList": "מחירון ציבורי קיים",
  "externalModule.ondoc.settings.listCurrency": "המטבע של המחירון שנבחר:",
  "externalModule.ondoc.settings.branchToken": "מפתח Import API של הסניף",
  "externalModule.ondoc.settings.addBranch": "הוספת התאמת סניף",
  "externalModule.ondoc.settings.doctorMapping": "התאמת רופא",
  "externalModule.ondoc.settings.doctor": "רופא ב־Terysling",
  "externalModule.ondoc.settings.specialization": "קוד ההתמחות ב־OnDoc",
  "externalModule.ondoc.settings.adults": "מקבל מבוגרים",
  "externalModule.ondoc.settings.childrenMin": "גיל מינימלי לילדים, אם מתקבלים ילדים",
  "externalModule.ondoc.settings.childrenMax": "גיל מקסימלי לילדים, אם מתקבלים ילדים",
  "externalModule.ondoc.settings.childrenHint": "אם הרופא אינו מקבל ילדים, יש להשאיר את שני שדות הגיל ריקים. אחרת יש להזין את שני הגבולות בטווח 0 עד 18.",
  "externalModule.ondoc.settings.addDoctor": "הוספת התאמת רופא",
  "externalModule.ondoc.settings.serviceMapping": "התאמת שירות",
  "externalModule.ondoc.settings.service": "שירות מתוך המחירון שנבחר",
  "externalModule.ondoc.settings.visitKind": "אופן מתן השירות",
  "externalModule.ondoc.settings.visit": "תור במרפאה",
  "externalModule.ondoc.settings.houseCall": "ביקור רופא בבית; קטלוג בלבד",
  "externalModule.ondoc.settings.appointmentType": "סוג תור שפורסם ב־Terysling",
  "externalModule.ondoc.settings.catalogueOnly": "קטלוג בלבד; ללא הזמנת תורים",
  "externalModule.ondoc.settings.duration": "משך הזמן בדקות",
  "externalModule.ondoc.settings.addService": "הוספת התאמת שירות",
  "externalModule.ondoc.settings.scheduleHint": "לכל לוח תורים ב־OnDoc יש רופא אחד, מקום עבודה אחד ושירותים של גרסה אחת שפורסמה של סוג תור.",
  "externalModule.ondoc.settings.scheduleMapping": "התאמת לוח תורים להזמנה",
  "externalModule.ondoc.settings.workplace": "מקום העבודה של הרופא",
  "externalModule.ondoc.settings.scheduledServices": "השירותים המוצעים בלוח התורים הזה",
  "externalModule.ondoc.settings.addSchedule": "הוספת התאמת לוח תורים",
  "externalModule.ondoc.journal": "יומן חילופי נתונים",
  "externalModule.ondoc.journalLimit": "מוצגות 200 הפעולות האחרונות. הסינון חל על רשימה זו.",
  "externalModule.ondoc.journalFailed": "לא ניתן לטעון את יומן חילופי הנתונים.",
  "externalModule.ondoc.journalRefresh": "רענון היומן",
  "externalModule.ondoc.journalLoading": "יומן חילופי הנתונים נטען…",
  "externalModule.ondoc.journalHidden": "יומן חילופי הנתונים אינו זמין כל עוד המודול מוסתר. יש לבטל את ההסתרה כדי לקרוא בו.",
  "externalModule.ondoc.journalUnavailable": "יומן חילופי הנתונים אינו זמין. ייתכן שהמודול הוסתר או הוסר עבור ארגון זה.",
  "externalModule.ondoc.operationKind": "פעולה",
  "externalModule.ondoc.operationCreated": "מועד יצירה",
  "externalModule.ondoc.operationCode": "קוד חיבור",
  "externalModule.ondoc.operationConnection": "עדכון מצב חיבור",
  "externalModule.ondoc.operationPublication": "פרסום מסמך רפואי",
  "externalModule.ondoc.operationWithdrawal": "משיכת מסמך רפואי",
  "externalModule.ondoc.operationDoctor": "פרסום רופא",
  "externalModule.ondoc.operationCatalogue": "שירותים ומחירים ציבוריים",
  "externalModule.ondoc.operationAvailability": "מועדים פנויים לקביעת תור",
  "externalModule.ondoc.operationBooking": "בקשה נכנסת לקביעת תור",
  "externalModule.ondoc.operationCancellation": "בקשה נכנסת לביטול תור",
  "externalModule.ondoc.operationAppointment": "חילופי מידע על תור",
  "externalModule.ondoc.operationAcknowledgement": "אישור טיפול בעדכון",
  "externalModule.ondoc.operationOther": "פעולה אחרת",
  "externalModule.ondoc.operationPending": "ממתינה לטיפול",
  "externalModule.ondoc.operationProcessing": "בטיפול",
  "externalModule.ondoc.operationCompleted": "הושלמה",
  "externalModule.ondoc.operationFailed": "שגיאה בחילופי הנתונים",
  "externalModule.ondoc.operationAmbiguous": "התוצאה אינה ידועה",
  "externalModule.ondoc.operationCanceled": "הוסרה מהטיפול",
  "externalModule.ondoc.operationPaused": "חילופי הנתונים הושהו",
  "externalModule.ondoc.openChart": "פתיחת תיק רפואי",
  "externalModule.ondoc.noOperations": "אין עדיין פעולות חילופי נתונים",
  "externalModule.ondoc.noOperationsDetail": "הפעולות יוצגו כאן לאחר תחילת חילופי הנתונים.",

  "externalModule.ondoc.operationActions": "פעולות",

  "externalModule.ondoc.medical.settingsTitle": "מסמכים רפואיים",
  "externalModule.ondoc.medical.mappingHint": "רק פרוטוקולים שנבחרו מתפרסמים אוטומטית לאחר אישור הרופא עבור מטופלים מקושרים. שליחת מסמכים קודמים דורשת בחירה ידנית.",
  "externalModule.ondoc.medical.sourceGrants": "בחירה דורשת הרשאות לקריאת פרוטוקולים וטופסי הדפסה.",
  "externalModule.ondoc.medical.mapping": "מיפוי מסמך",
  "externalModule.ondoc.medical.protocol": "פרוטוקול",
  "externalModule.ondoc.medical.documentType": "מדור OnDoc",
  "externalModule.ondoc.medical.printForm": "טופס הדפסה",
  "externalModule.ondoc.medical.language": "שפת PDF",
  "externalModule.ondoc.medical.consultations": "ייעוצים",
  "externalModule.ondoc.medical.exams": "בדיקות",
  "externalModule.ondoc.medical.analyzes": "בדיקות מעבדה",
  "externalModule.ondoc.medical.addMapping": "הוספת פרוטוקול",
  "externalModule.ondoc.medical.mappingInvalid": "יש לבחור פרוטוקול פעיל וטופס הדפסה ושפה התואמים לו.",

  "externalModule.ondoc.medical.historyTitle": "מסמכים רפואיים מאושרים",
  "externalModule.ondoc.medical.navLabel": "מסמכים רפואיים",
  "externalModule.ondoc.medical.navDetail": "שליחת מסמכים מאושרים של המטופל ל־OnDoc",
  "externalModule.ondoc.medical.sentTitle": "שליחות עבור מטופל זה",
  "externalModule.ondoc.medical.refresh": "רענון המסמכים",
  "externalModule.ondoc.medical.historyFailed": "לא ניתן לטעון מסמכים רפואיים או את היסטוריית הסנכרון.",
  "externalModule.ondoc.medical.manualHint": "יש לבחור מסמך מאושר כדי לשלוח את ה-PDF שהוגדר ל-OnDoc. מסמכים שאושרו בזמן שהמטופל לא היה מקושר נשלחים רק בבחירה מפורשת.",
  "externalModule.ondoc.medical.document": "מסמך",
  "externalModule.ondoc.medical.confirmedAt": "מועד האישור",
  "externalModule.ondoc.medical.author": "מחבר",
  "externalModule.ondoc.medical.send": "שליחה ל-OnDoc",
  "externalModule.ondoc.medical.sendNamed": "שליחה ל־OnDoc: {name}",
  "externalModule.ondoc.medical.sending": "הבקשה מתקבלת…",
  "externalModule.ondoc.medical.cancelSend": "ביטול",
  "externalModule.ondoc.medical.confirmSend": "להוסיף לתור את ה-PDF של המסמך המאושר שנבחר, לפי מיפוי הפרוטוקול של הארגון? המטופל חייב להיות מקושר כעת. קבלת הבקשה אינה מעידה שהפרסום הושלם.",
  "externalModule.ondoc.medical.accepted": "הבחירה התקבלה. תוצאת הסנכרון תופיע ביומן.",
  "externalModule.ondoc.medical.sendFailed": "לא ניתן לקבל את המסמך שנבחר לפרסום. הבחירה נשמרה.",
  "externalModule.ondoc.medical.mappingMissing": "לפרוטוקול זה אין מיפוי זמין למדור OnDoc, לתבנית הדפסה או לשפה. יש לפנות למנהל הארגון להגדרת המיפוי.",
  "externalModule.ondoc.medical.historyIncomplete": "למסמך המאושר אין נתוני הדפסה היסטוריים מלאים. לא ניתן להחליף אותם בנתונים העדכניים.",
  "externalModule.ondoc.medical.attachmentRequired": "המטופל חייב להיות מקושר כעת ל-OnDoc בסניף של המסמך או ברשת הארגון.",
  "externalModule.ondoc.medical.sourceChanged": "המסמך שנבחר השתנה או שאינו עוד הגרסה העדכנית המאושרת. יש לרענן את הרשימה ולבחור את הגרסה העדכנית.",
  "externalModule.ondoc.medical.doctorPending": "הרופא של המסמך טרם פורסם ב-OnDoc. יש לנסות שוב לאחר פרסום מיפוי הרופא.",
  "externalModule.ondoc.medical.noDocuments": "אין מסמכים מאושרים",
  "externalModule.ondoc.medical.noDocumentsDetail": "למטופל זה אין מסמכים עדכניים שאושרו על ידי רופא וזמינים לבחירה.",
  "externalModule.ondoc.medical.journalLimit": "מוצגות 200 פעולות הפרסום והמשיכה האחרונות של מסמכי המטופל.",

  "externalModule.ondoc.medical.operationPending": "למסמך זה כבר קיימת פעולת סנכרון שטרם הוכרעה. יש לברר את תוצאתה לפני בחירה בפרסום נוסף.",

  "externalModule.ondoc.outcome.openNamed": "בירור התוצאה: {name}",
  "externalModule.ondoc.outcome.title": "אישור התוצאה ב-OnDoc",
  "externalModule.ondoc.outcome.hint": "יש לבדוק את הפעולה המסוימת הזאת ב-OnDoc לפני אישור התוצאה. אישור שהפעולה לא בוצעה יאפשר ניסיון נוסף; פעולה שבוצעה תירשם בלי לחזור עליה.",
  "externalModule.ondoc.outcome.phase": "הפעולה לבדיקה",
  "externalModule.ondoc.outcome.reference": "מזהה מדויק ב-OnDoc",
  "externalModule.ondoc.outcome.version": "גרסת המסמך",
  "externalModule.ondoc.outcome.observation": "התוצאה שנבדקה",
  "externalModule.ondoc.outcome.applied": "בוצע ב-OnDoc",
  "externalModule.ondoc.outcome.notApplied": "לא בוצע ב-OnDoc",
  "externalModule.ondoc.outcome.checked": "בדקתי את הפעולה הזאת ב-OnDoc ואני מאשר את התוצאה שנבחרה.",
  "externalModule.ondoc.outcome.confirm": "שמירת התוצאה שנבדקה",
  "externalModule.ondoc.outcome.queued": "ההחלטה נשמרה. העיבוד יימשך כשיחודש הסנכרון; התוצאה תופיע ביומן.",
  "externalModule.ondoc.outcome.fileId": "מזהה הקובץ שהועלה ל-OnDoc",
  "externalModule.ondoc.outcome.fileHint": "יש להזין את המזהה המספרי שנבדק של קובץ ה-PDF המסוים שהועלה, ולא את מזהה המסמך.",
  "externalModule.ondoc.outcome.fileInvalid": "יש להזין מזהה חיובי תקין של קובץ OnDoc עבור ההעלאה שבוצעה.",
  "externalModule.ondoc.outcome.failed": "לא ניתן לקרוא או לשמור את התוצאה. הנתונים שהוזנו נשמרו.",
  "externalModule.ondoc.outcome.notReviewable": "הפעולה נמצאת בעיבוד, כבר הוכרעה או דורשת בירור אוטומטי של התוצאה המקומית. יש לרענן את היומן כדי לראות את המצב העדכני.",
  "externalModule.ondoc.outcome.changed": "הפעולה השתנתה לאחר הבדיקה. ההחלטה לא נשמרה; יש לטעון ולבדוק את הפעולה העדכנית לפני האישור.",
  "externalModule.ondoc.outcome.reload": "טעינת הפעולה מחדש וניקוי ההחלטה שהוזנה",
  "externalModule.ondoc.outcome.reloadFailed": "לא ניתן לטעון את הפעולה מחדש. ההחלטה שהוזנה נשמרה.",
  "externalModule.ondoc.outcome.unsaved": "החלטה שלא נשמרה לגבי תוצאת OnDoc",
  "externalModule.ondoc.outcome.discard": "למחוק את ההחלטה ומזהה הקובץ שהוזנו? לא תישמר תוצאה.",
  "externalModule.ondoc.outcome.upload": "העלאת ה-PDF",
  "externalModule.ondoc.outcome.create": "פרסום המסמך הרפואי",
  "externalModule.ondoc.outcome.update": "עדכון המסמך הרפואי שפורסם",
  "externalModule.ondoc.outcome.delete": "משיכת המסמך הרפואי",
  "externalModule.ondoc.outcome.eventCreate": "יצירת התור",
  "externalModule.ondoc.outcome.eventUpdate": "עדכון התור",
  "externalModule.ondoc.outcome.eventCancel": "ביטול התור",
  "externalModule.ondoc.outcome.doctorCreate": "פרסום הרופא",
  "externalModule.ondoc.outcome.appointmentAccept": "אישור הבקשה לתור",
  "externalModule.ondoc.outcome.appointmentReject": "דחיית הבקשה לתור",
  "externalModule.ondoc.outcome.cancellationAccept": "אישור בקשת הביטול",

}
